import { AppColors } from '@1js/acui-common';

import { SelectedPivotIndicatorStyles } from './SelectedPivotIndicator.styles';

export interface SelectedPivotIndicatorProps {
  /**
   * The custom app colors used to style the pivot indicator
   */
  appColors?: AppColors;

  /**
   * The position of the pivot indicator
   */
  position: number;

  /**
   * The offset of the pivot indicator
   */
  offset?: number;

  /**
   * The length of the pivot indicator in pixels
   */
  length: number;

  /**
   * Thickness of the indicator in pixels
   * Defaults to 3
   */
  thickness?: number;

  /**
   * True if the indicator should animate from it's previous state to the next
   */
  showAnimation: boolean;

  /**
   * Direction of the indicator
   * Default to Horizontal
   */
  direction?: SelectedPivotIndicatorDirection;

  /**
   * Custom styles for the pivot indicator
   */
  styles?: SelectedPivotIndicatorStyles;
}

export enum SelectedPivotIndicatorDirection {
  Horizontal,
  Vertical,
}
